import * as reactApp from 'reactApp';

export default function (app) {
  app.factory('klAccountService', [
    '$q',
    '$rootScope',
    '$http',
    'klSubscriptionService',
    function ($q, $rootScope, $http, SubscriptionService) {
      let _account = null;
      let _currency = null;
      let _subscriptions;

      const account$q = $q.defer();
      window.addEventListener('angular.payment.provider.loaded', (event) => {
        setAccount(event.detail);
        account$q.resolve(_account);
      });

      function fetchAccount() {
        return account$q.promise;
      }

      function verifyAddress(account) {
        return $http.get('/api/verification/address/', { params: account });
      }

      function getLicenseUsageChart(licenseId, timeSpan) {
        return $http
          .get(`/api/subscription/${licenseId}/usage/usageChart/${timeSpan}`)
          .then((response) => response.data);
      }

      function getLicenseUsageTable(licenseId, timeSpan) {
        return $http
          .get(`/api/subscription/${licenseId}/usage/usageTable/${timeSpan}`)
          .then((response) => response.data);
      }

      function getUsageActiveUsers(licenseId) {
        return $http
          .get(`/api/subscription/${licenseId}/usage/activeUsers/0`)
          .then((response) => response.data);
      }

      function getSubscriptions(options = {}) {
        if (!!_subscriptions && !options.force) {
          return $q.resolve(_subscriptions);
        }
        return $http.get('/api/account/subscription/all').then((response) => {
          if (!response.data.subscriptions) {
            return [];
          }
          _subscriptions = SubscriptionService.decorateRatePlans(
            response.data.subscriptions,
          );
          return _subscriptions;
        });
      }

      function getSubscription(subId, options = {}) {
        if (!!_subscriptions && !options.force) {
          return findSubscription(subId);
        }
        return getSubscriptions(options).then(() => findSubscription(subId));
      }

      function findSubscription(subId) {
        return $q((resolve) => {
          for (let i = 0; i < _subscriptions.length; i++) {
            if (_subscriptions[i].id == subId) {
              return resolve(_subscriptions[i]);
            }
          }
          resolve();
        });
      }

      function getFirstName() {
        if (!!getAccount() && getAccount().billToContact) {
          return getAccount().billToContact.firstName || '';
        } else {
          return '';
        }
      }

      function getAccount() {
        return _account;
      }

      function getPreviewAccount() {
        const preview = {
          currency: _currency,
        };
        if (_account) {
          preview.vatId = _account.vatId;
          preview.billToContact = _account.billToContact;
        }
        return preview;
      }

      function saveAccount(account) {
        return $http.put('/api/account', account).then(() => {
          setAccount(account);
          reactApp.setLastPaymentProviderUpdate();
          return _account;
        });
      }

      function setAccount(account) {
        if (!account) {
          return;
        }
        _currency = account.currency;
        _account = account;
      }

      function getCurrency() {
        return _currency;
      }

      function isReseller() {
        return !!_account && _account.isReseller;
      }

      function getResellerStatus() {
        return !!_account && _account.resellerStatus;
      }

      return {
        verifyAddress,
        fetchAccount,
        getSubscriptions,
        getSubscription,
        getAccount,
        getFirstName,
        saveAccount,
        getCurrency,
        getPreviewAccount,
        isReseller,
        getResellerStatus,
        getLicenseUsageChart,
        getLicenseUsageTable,
        getUsageActiveUsers,
      };
    },
  ]);
}
